// Version : 0.0.1
// Author : AGALAYA
// LastEdit : KARTHEESWARAN
//Last ADD : ADDING COMMENTS FOR FUNCTION
// MODFIED DATE:06-08-2025
/* eslint-disable import/no-anonymous-default-export */
import ProfileTypes from './profile.types';
import { docodeHexResponse } from '../_common/common.utils';
const INITIAL_STATE = {
	profileDetailsFetchResponse: null,
	getprofileDetailsArr: [],
	profileDetailsUpdateResponse: null,
	updatePasswordResponse: null,
	generateSecreteAuthKeyResponse: null,
	generateSecreteAuthKeyArr: [],
	profileImageUpdateResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET PROFILE DETAILS START *********************** */
		case ProfileTypes.GET_PROFILE_DETAILS_SUCCESS:
			return {
				...state,
				profileDetailsFetchResponse: action.payload,
				getprofileDetailsArr: docodeHexResponse(action.payload, 'FetchProfileDetailsKey'),
			};

		/** ***************** GET PROFILE DETAILS FAILURE *********************** */
		case ProfileTypes.GET_PROFILE_DETAILS_FAILURE:
			return {
				...state,
				profileDetailsFetchResponse: action.payload,
			};

		/** ***************** GET PROFILE DETAILS RESPONSE CHANGED *********************** */
		case ProfileTypes.GET_PROFILE_DETAILS_RESPONSE_CHANGED:
			return { ...state, profileDetailsFetchResponse: null };

		/** ***************** GET PROFILE DETAILS END *********************** */

		/** ***************** UPDATE PROFILE DETAILS START *********************** */

		case ProfileTypes.UPDATE_PROFILE_DETAILS_SUCCESS:
			return {
				...state,
				profileDetailsUpdateResponse: action.payload,
			};

		/** ***************** UPDATE PROFILE DETAILS FAILURE *********************** */
		case ProfileTypes.UPDATE_PROFILE_DETAILS_FAILURE:
			return { ...state, profileDetailsUpdateResponse: action.payload };

		/** ***************** UPDATE PROFILE DETAILS RESPONSE CHANGED *********************** */
		case ProfileTypes.UPDATE_PROFILE_DETAILS_RESPONSE_CHANGED:
			return { ...state, profileDetailsUpdateResponse: null };

		/** ***************** UPDATE PROFILE DETAILS END*********************** */

		/** ***************** UPDATE PASSWORD START *********************** */
		case ProfileTypes.UPDATE_PASSWORD_SUCCESS:
			return {
				...state,
				updatePasswordResponse: action.payload,
			};

		/** ***************** UPDATE PASSWORD DETAILS FAILURE*********************** */
		case ProfileTypes.UPDATE_PASSWORD_FAILURE:
			return { ...state, updatePasswordResponse: action.payload };

		/** ***************** UPDATE PASSWORD DETAILS RESPONSE CHANGED*********************** */
		case ProfileTypes.UPDATE_PASSWORD_RESPONSE_CHANGED:
			return { ...state, updatePasswordResponse: null };

		/** ***************** UPDATE PASSWORD END *********************** */

		/** ***************** GENERATE SECRETE AUTHKEY START *********************** */

		case ProfileTypes.GENERATE_SECRETE_AUTHKEY_SUCCESS:
			return {
				...state,
				generateSecreteAuthKeyResponse: action.payload,
				generateSecreteAuthKeyArr: docodeHexResponse(
					action.payload,
					'GenerateSecreteAuthKey',
				),
			};

		/** ***************** GENERATE SECRETE AUTHKEY FAILURE*********************** */
		case ProfileTypes.GENERATE_SECRETE_AUTHKEY_FAILURE:
			return { ...state, generateSecreteAuthKeyResponse: action.payload };

		/** ***************** GENERATE SECRETE AUTHKEY RESPONSE CHANGED*********************** */
		case ProfileTypes.GENERATE_SECRETE_AUTHKEY_RESPONSE_CHANGED:
			return { ...state, generateSecreteAuthKeyResponse: null };

		/** ***************** GENERATE SECRETE AUTHKEY END *********************** */

		/** ***************** UPDATE PROFILE IMAGE START *********************** */

		case ProfileTypes.UPDATE_IMAGE_SUCCESS:
			return {
				...state,
				profileImageUpdateResponse: action.payload,
			};

		/** ***************** UPDATE IMAGE FAILURE*********************** */
		case ProfileTypes.UPDATE_IMAGE_FAILURE:
			return { ...state, profileImageUpdateResponse: action.payload };

		/** ***************** UPDATE IMAGE RESPONSE_CHANGED*********************** */
		case ProfileTypes.UPDATE_IMAGE_RESPONSE_CHANGED:
			return { ...state, profileImageUpdateResponse: null };

		/** ***************** UPDATE PROFILE IMAGE END*********************** */

		default:
			return state;
	}
};
